module.exports = __webpack_public_path__ + "static/media/voucher-icon.29106e4b.png";